/** Company identity, navigation and contact details. Swap for a CMS payload later. */

export const site = {
  name: 'Green Circuit Recycling',
  tagline: 'Compliant E-Waste Management for Enterprises (A initative by Nishant Industries Pvt. Ltd.)',
  legalName: 'Green Circuit Recycling ',
  // cpcbId: 'CPCB/EPR/R-2024/018742',
  // gstin: '27AAFCE9182K1ZP',
  founded: 2026,
  email: 'Greencircuitrecycling@gmail.com',
  // supportEmail: 'compliance@greencircuit.example',
  phone: '+91 9310476884',
  // altPhone: '1800 419 8080',

  addressLines: [
    'Plot No. 119A, Sanjay Colony, Sector 22, Faridabad, Haryana - 121005'
  ],
  hours: [
    { day: 'Monday – Friday', time: '9:00 AM – 7:00 PM' },
    { day: 'Saturday', time: '9:00 AM – 2:00 PM' },
    { day: 'Sunday', time: 'Closed (pickups on request)' },
  ],
};

/** Primary navigation — order matters, used in header and footer. */
export const navLinks = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Services', to: '/services' },
  { label: 'Industries', to: '/industries' },
  { label: 'Process', to: '/process' },
  { label: 'Compliance', to: '/compliance' },
  { label: 'Contact', to: '/contact' },
];

export const footerLinks = [
  {
    title: 'Company',
    links: [
      { label: 'About Us', to: '/about' },
      { label: 'Our Process', to: '/process' },
      { label: 'Compliance', to: '/compliance' },
      { label: 'Contact', to: '/contact' },
    ],
  },
  {
    title: 'Services',
    links: [
      { label: 'Corporate E-Waste Pickup', to: '/services#corporate-pickup' },
      { label: 'Data Destruction', to: '/services#data-destruction' },
      { label: 'EPR Credit Management', to: '/services#epr-credits' },
      { label: 'IT Asset Disposition', to: '/services#itad' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Request a Pickup', to: '/request-pickup' },
      { label: 'FAQs', to: '/process#faq' },
      { label: 'Industries We Serve', to: '/industries' },
    ],
  },
];

// export const socials = [
//   { label: 'LinkedIn', href: 'https://www.linkedin.com', icon: 'linkedin' },
//   { label: 'Twitter', href: 'https://twitter.com', icon: 'twitter' },
//   { label: 'YouTube', href: 'https://youtube.com', icon: 'youtube' },
// ];

/** Logos rendered as styled wordmarks in the trust bar — no image assets needed. */
export const clientLogos = [
  'Syntax Soft-Tech',
  'Softlabs Infotech',
  'SMC International',
  'Suraj Technologies',
  'Ajay Kumar Garg Engineering College',
  'Lingaya\'s Vidyapeeth',
  'ABES Engineering College',
  'Shiv Nadar University',
  // 'Gautam Buddha University',
  'Sharda University',
  'Galgotias University',
  'IMS Engineering College',
  'Manav Rachna International Institute',

];
